<template>
<div>
<h4>Add audition</h4>
					<table>
				  <tr>
					<td>
				
				<div class="login-select">
								<select option id="TalkToMeBranchSelect"
													v-model:value="branchInput"
													onfocus="this.style.background-color='#000000';this.style.color='#c7b7a5';this.style.color='#c7b7a5';this.size=10;this.oldHeight=this.style.height;this.style.height='150px'"
													onblur='this.style.background-color="#000000";this.style.color="#FF632B";this.size=1;this.style.height=this.oldHeight'
													onchange='this.style.background-color="#000000";this.size=1; this.blur();'>
									<option>מרכז (תל אביב)</option>
									<option>צפון (חיפה)</option>
								</select>
							</div>
				
				
				</td>
					<td><input class="login_input" 
				autocomplete="off"
				placeholder="YYYY-MM-DD"
				v-model="auditionDay"/></td>
					<td><td><input class="login_input" 
				autocomplete="off"
				placeholder="HH:mm"
				v-model="auditionTime" v-on:keyup.enter="postAudition(auditionTime,auditionDay,branchInput)"/></td>
					<td>	<div class="submit_input" v-on:click="postAudition(auditionTime,auditionDay,branchInput)">
				<label>Add Audition</label>
			</div></td>
				  </tr>
				
			</table>
	<div  v-for="(data,site) in totalAuditions" >
		<div class="Audition" style="float:right;height:auto;max-width:500px"  v-for="auditionDay in data" >
			<div class="auditionBlock" style="height:auto;padding-bottom:406px;">
				<div class="auditionDate">
					<label class="auditionDateLabel">{{auditionDay.day}} {{translate(site)}}</label>
				</div>
				<div class="auditionSlots" style="width:auto;" >
					<div class="auditionSlot" style="width:100px;" :class="{auditionPicked : pickedTimeSlot === audition , auditionTaken : !audition.open}" v-for="audition in auditionDay.data">
						<label class="auditionSlotLabel">{{audition.hour}}</label>
						<button style="height:30px;" v-on:click="deleteAudition(audition)">
								Delete
						</button>
						<button v-if="audition.open" style="height:30px;" v-on:click="bookAudition(audition)">
								book
						</button>
						<button v-else style="height:30px;" v-on:click="unbookAudition(audition)">
								unbook
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>	
</div>
</template>

<script>
  import axios from 'axios'
  var APIbase = "https://yard-bands.herokuapp.com"
  export default {
    components: {
    },
	created () {
		console.log(this.auditionType)
		this.fetchAuditions();
	},
	data() {
		return {
			totalAuditions: {},
			timeTillEnd: "10",
			pickedDay:0,
			pickedTimeSlot: {},
			userId: "",
			branchInput : 'מרכז (תל אביב)'
		}
	},
	computed: {
		daysLeftForRegistration : function () {
			return this.days_between(new Date('2017-09-06'),new Date())
		}
	},
	watch: {
		
	},

	methods: {
		translate(site) {
			if (site === 'center') {
				return 'מרכז (תל אביב)';
			}
			if (site === 'north') {
				return 'צפון (חיפה)';
			}
		},
		postAudition(time, day,site_trans) {
			var site = null
			if (site_trans === 'מרכז (תל אביב)') {
				site = 'center';
			}
			if (site_trans === 'צפון (חיפה)') {
				site = 'north';
			}
			if (site == null) {
				return
			}
			axios.post(APIbase+'/v2/auditionsRaw',{"time":time,
												"day": day, "site":site}).then(response => {
				this.fetchAuditions();
			}).catch(function (error) {
				
			});
		},
		days_between(date1, date2) {

			// The number of milliseconds in one day
			var ONE_DAY = 1000 * 60 * 60 * 24

			// Convert both dates to milliseconds
			var date1_ms = date1.getTime()
			var date2_ms = date2.getTime()

			// Calculate the difference in milliseconds
			var difference_ms = Math.abs(date1_ms - date2_ms)

			// Convert back to days and return
			return Math.round(difference_ms/ONE_DAY)

		},
		deleteAudition(audition) {
			
			axios.delete(APIbase+'/v2/auditionsRaw',{data:{"time":audition.hour,
												"day": audition.day,"site": audition.site}}).then(response => {
				for (var i=0; i< this.totalAuditions[audition.site].length; i++){
					this.totalAuditions[audition.site][i].data = this.totalAuditions[audition.site][i].data.filter(function(item) { 
						return !(item.day == audition.day && item.hour == audition.hour && item.site == audition.site)
					})	
				}
				this.fetchAuditions ();
			}).catch(function (error) {
				
			});
		},
		fetchAuditions () {
			axios.get(APIbase+'/v2/auditions/').then(response => {
       			// Process each site's auditions
				let processed = {};
				for (let site in response.data) {
					// Filter and sort auditions for each site
					processed[site] = response.data[site]
						// Sort by date
						.sort((a, b) => {
							let [dayA, monthA, yearA] = a.day.split('/');
							let [dayB, monthB, yearB] = b.day.split('/');
							return new Date(`20${yearA}`, monthA-1, dayA) - new Date(`20${yearB}`, monthB-1, dayB);
						});
				}
				this.totalAuditions = processed;

				if (this.site) {
					this.auditionsDays = this.totalAuditions[this.site] || [{day:'',data:[]}];
					this.auditionsDaysComplete = this.auditionsDays.map(n => 
						n.data && n.data.some(c => c.open) ? false : true
					);
					if (this.auditionsDays != null && this.auditionsDays.length > 0) {
						this.auditionCurrentDate = this.auditionsDays[this.pickedDay].day;
					}
				}
			});
		},
		bookAudition(audition) {
			
			axios.post(APIbase+'/v2/book_audition_admin',{"hour":audition.hour,
												"day": audition.day, "site": audition.site}).then(response => {
				this.fetchAuditions ()
			}).catch(function (error) {
				
			});
		},
		unbookAudition(audition) {
			
			axios.post(APIbase+'/v2/unbook_audition_admin',{"hour":audition.hour,
												"day": audition.day, "site": audition.site}).then(response => {
				this.fetchAuditions ()
			}).catch(function (error) {
				
			});
		}
	}

  }
</script>



// WEBPACK FOOTER //
// AdminAudition.vue?6f858c8e